<template>
  <div class="invitation-mine">
    <div class="invite-tabs">
      <div class="invite-tabs-item" v-for="(item, index) in tabsList" :key="item.index" @click="bindTabs(item)">
        <span class="title" :class="[active === index ? 'active' : '']">{{item.title}}</span>
      </div>
    </div>

    <div class="invite-radio">
      <van-radio-group v-model="appointPlaceId" @change="onChange" direction="horizontal">
        <van-radio :name="address.placeId" checked-color="#EA592A" icon-size="15px" v-for="address in addressList" :key="address.placeId">{{address.placeName}}</van-radio>
      </van-radio-group>
    </div>

    <div class="invite-tabs-content">
      <InviteCard :active="active" :data="inviteList" />
    </div>

    <Loading v-model="loading" />
  </div>
</template>

<script>
  import Loading from '@/components/Loading'
  import Empty from '@/components/Empty'
  import InviteCard from './components/InviteCard'

  export default {
    components: {
      Loading,
      InviteCard,
      // Empty
    },
    data() {
      return {
        active: 0,
        loading: false,
        tabsList: [
          { title: '已完成预约', index: 0 },
          { title: '未完成预约', index: 1 },
        ],
        addressList: [],
        inviteList: [],
        appointPlaceId: "" // 预约地点id
      }
    },
    mounted() {
      this.getList()
      this.getPlaceList()
    },
    methods: {
      getList() {
        const params = {
          pageNum: 1,
          pageRows: 10,
          appointPlaceId: this.appointPlaceId || undefined,
          status: this.active === 0 ? 'APPROVE' : 'PENDING'
        }

        this.$Toast.loading({
          duration: 10000,
          message: '加载中...',
          forbidClick: true,
        })
        this.$http.getAppointmentList(params).then(res => {
          if (res.code === 1000) {
            this.inviteList = res.data.list
            this.$Toast.clear()
          }
        })
      },
      getPlaceList() {
        this.$http.getAppointmentPlace({terminal: "wechat"}).then(res => {
          if (res.code === 1000) {
            this.addressList = res.data.map(item => {
              if (item.placeId === "d33549020c0c73d4a3bf040363f70c8d") {
                item.placeName = '洽谈区'
              }
              return item
            })
          }
        })
      },
      bindTabs(item) {
        this.active = item.index

        if (this.appointPlaceId) {
          this.appointPlaceId = ""
        }

        this.getList()
      },
      onChange(value) {
        this.appointPlaceId = value

        if (value) {
          this.getList()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invitation-mine {
    padding: 12px;
  }
  .invite-tabs {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .invite-tabs-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .invite-tabs-item .title {
    font-weight: 500;
    font-size: 15px;
    color: #666666;
    padding: 6px 40px;
    border-radius: 16px;
    background: #ffffff;
  }
  .invite-tabs-item .title.active {
    font-weight: 600;
    color: #FFFFFF;
    background: #EA592A;
  }

  .invite-radio {
    padding: 12px 0;
    ::v-deep .van-radio__label {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .invitation-content {
    padding-top: 12px;
  }
</style>
